{
  "aNotificationWillBeSendToToAllLinkedPhoneNumbersWhenAnyOfTheseStateChangesOccurs": "A notification will be send to to all linked phone numbers when any of these state changes occurs...",
  "aboutCustomNotifications": "About Custom Notifications",
  "addYourPhoneNumber": "Add your phone number",
  "autoMutedExplanation": "This device was automatically muted because it was sending too many notifications. You can unmute it to resume receiving notifications.",
  "changesFrom": "changes from: ",
  "createNotificationHelpBodyText": "By default, FarmHQ will attempt to notify all members of your farm account when something important happens.\n\nIf you want to receive customized notifications for specific devices, you can set notification rules here.\n\nFarmHQ can notify you when a sensor on your device changes from one state to another. Make sure that users of your farm account have verified their phone numbers in their account settings.\n\nYou must have permission to manage custom notification in order to create or delete notification rules.",
  "deleteThisRule": "Delete this Rule?",
  "deviceMuted": "Device Muted",
  "deviceMutedBanner": "All notifications from this device are currently muted.",
  "errorMessageAlreadyCreated": "This rule already exists for this device.",
  "muteDevice": "Mute Device",
  "newNotificationRule": "New Notification Rule",
  "newRule": "New Rule",
  "noCustomNotificationRulesHaveBeenCreatedForThisDevice": "No custom notification rules have been created for this device.",
  "noVerifiedPhoneNumbersMessage": "You have no verified phone numbers.\nYou can register and verify phone numbers in your account settings menu.",
  "noVerifiedPhoneNumbersTitle": "No Verified Phone Numbers",
  "notificationRules": "Notification Rules",
  "notifications": "Notifications",
  "notificationsDisabled": "Notifications Disabled",
  "notificationsEnabled": "Notifications Enabled",
  "sendANotificationToAllPhoneNumbersWhenThisStateChangeHappens": "Send a notification to all phone numbers when this state change happens...",
  "sendANotificationWhen": "Send a notification when...",
  "unmute": "Unmute",
  "notificationChannel": "Notification Channel",
  "notificationChannelDescription": "Choose how you receive notifications from your devices.",
  "channelSms": "SMS Only",
  "channelPush": "Push Only",
  "channelBoth": "SMS & Push",
  "channelNone": "None",
  "channelPreferenceUpdated": "Notification channel preference updated.",
  "notificationMode": "Notification Mode",
  "notificationModeEnabled": "Enabled",
  "notificationModeSuppressed": "Suppressed",
  "notificationPreferences": "Notification Preferences",
  "managePhoneNumbers": "Manage Phone Numbers",
  "manageNotificationsByDevice": "Manage Notifications by Device",
  "viewNotificationMap": "View on Map",
  "notificationMapTitle": "Notification Map",
  "legendEnabled": "Active",
  "legendSuppressed": "Muted for Me",
  "legendMuted": "Muted for All Users",
  "noDevicesMessage": "No devices found.",
  "personalPreferencesOnly": "These preferences apply only to your account.",
  "manageDevicesDescription": "These settings only affect your notifications. Other users' preferences are not changed.",
  "affectsOnlyYou": "This setting affects only your notifications.",
  "muteForAllUsers": "Mute for All Users",
  "muteForAllUsersDescription": "When muted, no users will receive notifications from this device.",
  "mutedByUserAt": "Muted by {{email}} on {{date}}.",
  "autoMutedAt": "Automatically muted on {{date}} due to excessive notifications.",
  "notificationSettings": "Notification Settings",
  "muteForMe": "Mute for Me",
  "muteForMeDescription": "Mute notifications from this device for your account only.",
  "mutedForMe": "Muted for you",
  "unmutedForMe": "Unmuted for you",
  "deviceMuteStatus": "Device Mute",
  "stateEnabled": "Enabled",
  "stateMutedForMe": "Muted for Me",
  "stateMutedForAll": "Muted for All",
  "disabledByAdmin": "Notifications disabled by an admin.",
  "sendTestNotification": "Send Test Notification",
  "sendTestNotificationQuestion": "Send a test notification?",
  "sendTestToMe": "Send Test to Me",
  "sendTestToFarm": "Send Test to Everyone",
  "testNotificationDescription": "Send yourself a test to confirm notifications are working, or test everyone on your farm.",
  "testNotificationFarmWarning": "All users on this farm will receive this test notification, using their own notification settings.",
  "testNotificationDeviceWarning": "All users configured to receive notifications for this device will receive this test notification.",
  "testNotificationSent_one": "Test notification sent to {{count}} recipient.",
  "testNotificationSent_other": "Test notification sent to {{count}} recipients.",
  "testNotificationPermissionRequired": "You need permission to manage device notifications to test everyone on your farm."
}
